import PropTypes from 'prop-types';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';
import SnackbarSpinner from './SnackbarSpinner';

export default function SnackbarProcessing({ message }) {
    return (
        <SnackbarCard>
            <SnackbarLayout>
                <div>
                    <SnackbarSpinner size={20} />
                </div>
                <SnackbarContent>
                    <div className="text-xs">{message}</div>
                </SnackbarContent>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarProcessing.propTypes = {
    message: PropTypes.string.isRequired,
};
